import { api, unwrap } from '@saas-kit/lib';

export type BillingInterval = 'monthly' | 'yearly' | 'custom';

export interface AdminPlan {
  id: string;
  code: string;
  name: string;
  description: string | null;
  is_active: boolean;
  billing_interval: BillingInterval;
  currency: string;
  unit_amount: string;
  trial_days: number;
  metadata: Record<string, unknown>;
}

export interface AdminPage {
  total: number;
  offset: number;
  limit: number;
}

export interface AdminPlanList {
  items: AdminPlan[];
  page: AdminPage;
}

export interface ListPlansParams {
  offset?: number;
  limit?: number;
  include_inactive?: boolean;
}

export interface CreatePlanPayload {
  code: string;
  name: string;
  description?: string | null;
  billing_interval: BillingInterval;
  currency: string;
  unit_amount: string;
  trial_days?: number;
  is_active?: boolean;
  metadata?: Record<string, unknown>;
}

export interface UpdatePlanPayload {
  name?: string | null;
  description?: string | null;
  billing_interval?: BillingInterval | null;
  currency?: string | null;
  unit_amount?: string | null;
  trial_days?: number | null;
  is_active?: boolean | null;
  metadata?: Record<string, unknown> | null;
}

export async function listPlans(
  params: ListPlansParams = {},
): Promise<AdminPlanList> {
  return unwrap<AdminPlanList>(
    api.get('/admin/billing/plans', {
      params: {
        offset: params.offset ?? 0,
        limit: params.limit ?? 50,
        include_inactive: params.include_inactive ?? true,
      },
    }),
  );
}

export async function createPlan(payload: CreatePlanPayload): Promise<AdminPlan> {
  return unwrap<AdminPlan>(api.post('/admin/billing/plans', payload));
}

export async function updatePlan(
  planId: string,
  payload: UpdatePlanPayload,
): Promise<AdminPlan> {
  return unwrap<AdminPlan>(api.patch(`/admin/billing/plans/${planId}`, payload));
}

export async function archivePlan(planId: string): Promise<AdminPlan> {
  return unwrap<AdminPlan>(api.delete(`/admin/billing/plans/${planId}`));
}
